import { Component, OnInit } from '@angular/core';
import { AuthService, Dropobj,MasterService } from '../../services/index';

import { HttpClient } from '@angular/common/http';

import {Subject, Observable} from 'rxjs';
import {NgbModal, ModalDismissReasons,NgbModalOptions,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-logs',
  templateUrl: './logs.component.html',
  styleUrls: ['./logs.component.scss'],
  providers:[AuthService,MasterService]
})
export class LogsComponent implements OnInit {

 
  // books: Book[];
  memberdetails:any[]=[];
  classdetails:any[]=[];
  issuedetails:any=[];
  closeResult: string;
  classes: Dropobj[];
  section: Dropobj[];
  student:boolean=true;
  staff:boolean=false;
  memberdash:any={};
  modalOptions:NgbModalOptions;
  private modalRef: NgbModalRef;
  private modalRef1: NgbModalRef;
  studentinfo:any={};
  arrgender=[{value:'M',name:'Male'},{value:'F',name:'Female'},{value:'O',name:'Other'}];
  arrmemtype=[{value:'S',name:'staff'},{value:'V',name:'visitor'}];


    
objlink:any={};
objstfdata:any={};
stumemdata:any={};
arrmnulst:any=[];
arrrolesact:any=[];
arrmnugrp:any=[];
arrmycp:any=[];
arrroleacdet:any=[];
arrrolesall:any=[];
objrole:any={};
fileToUpload: File = null;
defclass:any=0;
selgrp:any=0;
selrole:any=0;
selmnu=''
fData: FormData = new FormData;
memid:any;
memstusave=false;
arrmnulinks:any=[];

arrstatus=[{name:'YES'},{name:'NO'}];

fserdt:any;
fserdt4:any;
  constructor(private http: HttpClient,private mservice:MasterService, private liservice: AuthService,private modalService: NgbModal) 
  {

    this. getdatetoday();
   }


  

  

  _keyPress(event: any) {
    if (event.charCode !== 0) {
      const pattern = /[0-9\+\-\ ]/;
      const inputChar = String.fromCharCode(event.charCode);

      if (!pattern.test(inputChar)) {
        // invalid character, prevent input
        event.preventDefault();
      }
    }
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }



  ngOnInit(): void {
    
    this. getdatetoday();
    
    //this.getmnulinks();
  
 
  }

  getdatetoday() {
    this.liservice.getsysdatetoday()
        .subscribe(
        resultArray => {
            console.log('getlibsource', resultArray);
            this.fserdt = resultArray;
            this.fserdt4 = resultArray;
            this.getuserlog();
            
        },
        error => console.log("Error :: " + error)
        )
  }
  






  
  
 
 
 protected getuserlog() {
    this.liservice.getuserlog(this.fserdt,this.fserdt4)
        .subscribe(
        resultArray => {
            console.log('arrrolesall', resultArray);
            this.arrrolesall = resultArray;
          //  this.objstfdata.clid=resultArray[0].desid;
            //this.objstfdata.defblgrp=resultArray[0].blgpnm;
           
        },
        error => console.log("Error :: " + error)
        )
  }

  exportrecord(){
    var clcd=localStorage.getItem('clcd');
    var aycd=localStorage.getItem('aycd');
     var url=this.liservice.callurl+"export/expmycplogs.php?clcd="+clcd+"&aycd="+aycd;
  
     window.open(url,'');
   }

  protected getmycplog() {
    this.liservice.getmycplog()
        .subscribe(
        resultArray => {
            console.log('arrrolesall', resultArray);
            this.arrmycp = resultArray;
          //  this.objstfdata.clid=resultArray[0].desid;
            //this.objstfdata.defblgrp=resultArray[0].blgpnm;
           
        },
        error => console.log("Error :: " + error)
        )
  }

}

